import React from 'react';
import pluralize from 'pluralize';

import { formatDate } from '../../helpers';

import type { Timeline } from '../../types/timeline';

const TimelineMeta: React.FC<{ timeline: Timeline }> = ({ timeline }) => {
  return (
    <div className="timeline-meta wa-cluster wa-gap-0">
      <span>
        {pluralize('memory', timeline.memories.length, true)}
      </span>
      <span>
        Started {formatDate(timeline.created_at)}
      </span>
    </div>
  );
}

export default TimelineMeta;
